<template>
  <div class="contact-modal">
    <div class="modal-header">
      <span>添加联系人</span>
      <i class="close" @click="cancel"></i>
    </div>
    <div class="modal-content">
      <div class="form-item">
        <div class="form-item-label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</div>
        <div class="form-item-value" :class="formData.linkman.error ? 'error' : ''">
          <input type="text" placeholder="请输入姓名" v-model="formData.linkman.value" />
          <div class="error-tip">{{formData.linkman.error}}</div>
        </div>
      </div>
      <div class="form-item">
        <div class="form-item-label">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务：</div>
        <div class="form-item-value">
          <select :value="formData.postDicKey.value" @change="e => selectChange(e, 'postDicKey')">
            <option v-for="(item, index) in formData.postDicKey.options" :key="index" :value="item.value">{{item.name}}</option>
          </select>
        </div>
      </div>
      <div class="form-item">
        <div class="form-item-label">办公电话：</div>
        <div class="form-item-value" :class="formData.officePhone.error ? 'error' : ''">
          <input type="text" placeholder="请输入办公电话" v-model="formData.officePhone.value" />
          <div class="error-tip">{{formData.officePhone.error}}</div>
        </div>
      </div>
      <div class="form-item">
        <div class="form-item-label">移动电话：</div>
        <div class="form-item-value" :class="formData.mobilePhone.error ? 'error' : 'info'">
          <input type="text" placeholder="请输入移动电话" v-model="formData.mobilePhone.value" />
          <div class="error-tip">{{formData.mobilePhone.error || '移动电话将同步生成帐号，请谨慎填写'}}</div>
        </div>
      </div>
      <div class="form-item">
        <div class="form-item-label">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</div>
        <div class="form-item-value" :class="formData.mailbox.error ? 'error' : ''">
          <input type="text" placeholder="请输入邮箱" v-model="formData.mailbox.value" />
          <div class="error-tip">{{formData.mailbox.error}}</div>
        </div>
      </div>
      <hr>
      <div class="notice-tip">
        <img src="../../../assets/images/icon-tip.png" alt="" class="icon-notice" />
        <div>标有星号(*)的栏目为必填栏目，并请验证邮箱和手机。您的个人信息不会透露给任何
第三方，请放心填写</div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="cancel" @click="cancel">取消</button>
      <button class="confirm" @click="confirm">确定</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    formData: {
      type: Object
    }
  },
  methods: {
    selectChange(e, fieldName) {
      const value = e.target.value;
      const field = this.formData[fieldName];
      field.value = value;
    },
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      for(let key in this.formData) {
        const field = this.formData[key];
        if (field instanceof Object === false) break;
        if (field.validate && !field.validate(field.value)) {
          return false;
        }
        field.error = false;
      }
      this.$emit('confirm');
    }
  }
}
</script>

<style lang="less" scoped>
.contact-modal {
  width: 640px;
  background: #FFFFFF;
  padding: 30px 0;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.0600);

  .modal-header {
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url(../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .modal-content {
    margin-bottom: 20px;

    .form-item {
      padding: 0 40px 0 56px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      &-label {
        width: 80px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        margin-right: 20px;
      }

      &-value {
        flex: 1;
        height: 46px;
        background: #F5F5F5;
        position: relative;

        .error-tip {
          position: absolute;
          left: 0;
          top: 100%;
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
          display: none;
        }

        &.error {
          border: 1px solid #FF3B2F;

          .error-tip {
            display: block;
          }
        }

        &.info {
          .error-tip {
            display: block;
            color: #06AE63;
          }
        }

        input {
          width: 80%;
          height: 100%;
          padding: 0 16px;
        }

        > select {
          width: 100%;
          height: 100%;
          border-radius: 2px;
          border: 1px solid #E6E7EB;
          outline: none;
          text-align: center;

          option {
            width: 41px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1B2841;
            line-height: 22px;
          }
        }
      }
    }

    hr {
      height: 1px;
      background: #EEEEEE;
      margin: 16px 0 20px 0;
    }

    .notice-tip {
      padding: 0 40px 0 56px;
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      line-height: 24px;

      .icon-notice {
        width: 16px;
        height: 16px;
        display: block;
        margin-top: 4px;
        margin-right: 8px;
      }
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06AE63;
        background: rgba(6,174,99,0.1000);
      }

      &.confirm {
        background: #06AE63;
        color: #FFFFFF;
      }
    }
  }
}
</style>